import { Component, Input, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { CustomErrorStateMatcher } from '../../models/custom-error-state';
import { IItem } from '../../models/group-edit-config';

@Component({
  selector: 'app-input-edit-percentage',
  templateUrl: './input-edit-percentage.component.html',
  styleUrls: ['./input-edit-percentage.component.scss'],
  providers: [
    {
        provide: NG_VALUE_ACCESSOR,
        multi: true,
        useExisting: InputEditPercentageComponent
    }
  ]
})
export class InputEditPercentageComponent implements ControlValueAccessor {
    @Input() errorState = new CustomErrorStateMatcher();
    
    localConfig!: IItem;
    @Input() set config(_c : IItem){
        this.localConfig = _c;
    }

    disabled = false;

    constructor() { }

    onChange = (value: number) => {}
    onTouched = () => {}


    localValue: number = 0
    underlyingValue: number = 0;

    keyUp(e: any) {
        this.localValue = e.target.value;
    }

    blur() {
        const newUnderlyingValue = this.localValue / 100;
        this.onChange(newUnderlyingValue);
    }

    focus(){
        this.onTouched();
    }

    registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    registerOnTouched(fn: any): void {
        this.onTouched = fn;
    }

    writeValue(obj: any): void {
        this.underlyingValue = obj;
        this.localValue = obj * 100;
    }

    setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
    }
}

export const fixDecimalPlaces = (num: number, dps?: number): number => {
    if(!dps){
        dps = 2;
    }
    
    return parseFloat(num.toFixed(dps));
}

export const formatPercentage = (num: any) => {
    return fixDecimalPlaces(num * 100, 1).toString() + '%';
}